import { Icon, Icons } from '@eduact/ed-components'
import { DoubleNextIcon } from '@Features/Progress/Assets/Icons'
import React from 'react'
import styled from 'styled-components'

type Props = {
	opened: boolean
	onClick: () => void
}
const MobileToggleButton: React.FC<Props> = ({ onClick, opened }) => {
	return (
		<StyledToggleButton opened={opened} onClick={onClick}>
			<Icon color="primary">
				<Icons.DoubleArrowUp />
			</Icon>
		</StyledToggleButton>
	)
}

export default MobileToggleButton

const StyledToggleButton = styled.div<{ opened: boolean }>`
	cursor: pointer;
	width: fit-content;
	transition: all ease-in-out 200ms;
	height: fit-content;

	transform: ${props => props.opened && 'rotate(180deg)'};
`
